// Bouwrun R1, baan E — de woorden van de labels op het scherm, op één plek.
//
// Elke functie valt terug op het oude scherm als de API het veld (nog) niet
// levert: dan geeft hij null en tekent de aanroeper niets extra's. De regels
// zelf (wanneer iets "afgeleid" of "onzeker" heet) rekent de server
// (service/src/sof/readapi/schermen.py, config/schermen.yaml); hier staat
// alleen hoe het er voor de lezer uitziet.

/** H2: "2025 · onderzoek", "jaar onbekend · beleid", of null zonder velden. */
export function jaarSoortTekst(bron: { jaar?: string | null; soort?: string | null }): string | null {
  if (!bron.jaar && !bron.soort) return null;
  const jaar = !bron.jaar || bron.jaar === "onbekend" ? "jaar onbekend" : bron.jaar;
  const soort = !bron.soort || bron.soort === "onbekend" ? "soort onbekend" : bron.soort;
  return `${jaar} · ${soort}`;
}

/** K4: de trede van een koppeling in gewone taal. */
export const TREDE_LABEL = {
  bron_zegt_zelf: "de bron zegt het zelf",
  zelfde_bron_afgeleid: "zelfde bron, afgeleid",
  zelfde_onderwerp_andere_bron: "zelfde onderwerp, andere bron",
} as const;

export const TREDE_UITLEG = {
  bron_zegt_zelf: "Het document dat de trend beschrijft, noemt deze vaardigheid erbij — en de twee citaten gaan over hetzelfde.",
  zelfde_bron_afgeleid:
    "Het document noemt beide, maar de twee citaten gaan niet over hetzelfde. De koppeling is afgeleid, geen uitspraak van de bron.",
  zelfde_onderwerp_andere_bron: "Een andere bron over hetzelfde onderwerp; de leeslaag legde de koppeling.",
} as const;

/** K1: twee zekerheden in woorden. "zeker" vanaf 0,8, "twijfel" eronder. */
export function zekerheidWoord(kans: number): string {
  return kans >= 0.8 ? "zeker" : kans >= 0.5 ? "twijfel" : "onzeker";
}

export function tweeZekerheden(v: {
  zekerheidVerband?: number;
  zekerheidNodig?: number;
}): string | null {
  if (typeof v.zekerheidVerband !== "number" || typeof v.zekerheidNodig !== "number") return null;
  return `verband: ${zekerheidWoord(v.zekerheidVerband)} (${v.zekerheidVerband.toFixed(2)}) · nodig: ${zekerheidWoord(v.zekerheidNodig)} (${v.zekerheidNodig.toFixed(2)})`;
}

/** F2: "recent" is geen nieuws; het krijgt een neutrale pil, geen groene. */
export function versheidToon(versheid: string | null | undefined): "groen" | "grijs" {
  return versheid === "recent" ? "grijs" : "groen";
}

/** W5/W3: de stempel zoals het scherm hem noemt. */
export function stempelTekst(b: {
  laag?: string | null;
  tekst: string;
  verplichting?: boolean;
  ouderBewijs?: boolean;
}): string {
  if (b.verplichting) return "bevestigd (verplichting)";
  if (b.ouderBewijs) return `${b.tekst} · ouder bewijs`;
  return b.tekst;
}

/** P2: regels die het scherm zelf maakt heten "illustratief voorstel". */
export const ILLUSTRATIEF_LABEL = "illustratief voorstel";
export const ILLUSTRATIEF_UITLEG =
  "De maand en de aanleerbaarheid van deze regel zijn voorbeeldwaarden die het scherm zelf invult (een rekenregel), geen bewijs uit een bron.";

/** E3 / L2: de etiketten bij wat het platform afleidt. */
export const AFGELEID_UITLEG =
  "Deze tekst schreef het platform op basis van de bronnen; het is geen citaat. Wat een bron letterlijk zegt, staat bij de bronnen.";
export const ONZEKER_LABEL = "onzeker";
export const ONZEKER_UITLEG =
  "Deze bevinding heeft geen letterlijk citaat uit het document: het is een samenvatting van het platform, geen bronfeit.";
export const ONDERBOUWING_ONTBREEKT = "onderbouwing ontbreekt";
